import './Offers.css';

const Offers = () => {
  return (
    <section className="offers-section" id="offers">
      <div className="container">
        <br>
        </br>
        <br>
        </br><br>
        </br>
        <h2>विशेष प्रस्तावहरू</h2>
        <br></br>
        <p>हाम्रो विशेष छुट प्रस्तावहरूबाट लाभ उठाउनुहोस् र ठूलो बचत गर्नुहोस्!</p>
        <br></br>
        <div className="offer-cards">
          <div className="offer-card">
            <div className="offer-icon">🗓️</div>
            <h3>आइतबार-बुधबार छुट</h3>
            <p>आइतबार र बुधबार सबै आलु प्याजमा १५% छुट</p>

          </div>

          <div className="offer-card">
            <div className="offer-icon">📦</div>
            <h3>बोरा लादा छुट</h3>
            <p>एक बोरा  किन्नुहोस् र १०% थप छुट पाउनुहोस्</p>
            <div className="quantity-info">


            </div>
          </div>

          <div className="offer-card">
            <div className="offer-icon">🚚</div>
            <h3>मुफ्त वितरण</h3>
            <p>₹५००० भन्दा बढीको अर्डरमा मुफ्त वितरण</p>

          </div>
        </div>

        {/* Additional Offer Details */}
        <div className="offer-terms">
          <h3>प्रस्तावका नियमहरू:</h3>
          <ul>
            <li>आइतबार-बुधबार छुट केवल आलु र प्याजमा लागू हुन्छ</li>
            <li>बोरा छुट प्रत्येक २५ किलोको लागि लागू हुन्छ</li>
            <li>मुफ्त वितरण केवल काठमाडौं उपत्यकामा मात्र</li>
            <li>प्रस्ताव सीमित समयसम्म मात्र लागू हुनेछ</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Offers;